module.exports = __webpack_public_path__ + "static/img/取衣.2416489d.png";